import { css } from '@primeuix/styled';

export const style = css`
    .p-orderlist {
        display: flex;
        gap: dt('orderlist.gap');
    }

    .p-orderlist-controls {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: dt('orderlist.controls.gap');
    }
`;
